import clsx from "clsx";
import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

export const FilterDropdown = ({
  options = [],
  onSelect = () => {},
  className,
  selectedOption,
  setSelectedOption,
  selectedOptionClass,
  optionsClass,
  dropdownClass,
  selectedClass,
  trailingIcon,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setIsOpen(false);
    onSelect(option);
  };

  return (
    <div className={`relative ${className}`} ref={dropdownRef}>
      <div
        className={clsx(
          "flex px-2 py-1 rounded-[7px] items-center justify-between w-[90px] cursor-pointer",
          selectedClass
        )}
        onClick={() => setIsOpen(!isOpen)}
      >
        <p className={clsx("text-xs font-medium truncate", selectedClass)}>
          {selectedOption.key}
        </p>

        <motion.div
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.2 }}
        >
          {trailingIcon}
        </motion.div>
        {/**/}
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <div
          className={clsx(
            "absolute top-full left-0 mt-1 rounded-[7px] shadow-lg z-50",
            dropdownClass
          )}
        >
          <div className="py-1">
            {options.map((option, index) => (
              <div
                key={index}
                className={clsx(
                  "px-2",
                  optionsClass,
                  selectedOption.value === option.value && selectedOptionClass
                )}
                onClick={() => handleOptionSelect(option)}
              >
                {option.key}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
